import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "player-shell"
};
const _hoisted_2 = {
  class: "player-loading"
};
const _hoisted_3 = {
  class: "ms-2"
};
const _hoisted_4 = {
  class: "player-inner"
};
const _hoisted_5 = {
  ref: "videoplayer",
  class: "video-js vjs-default-skin sbn-video-player",
  "data-setup": "{\"fluid\": true}"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_createVNode(_component_b_spinner), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.video.message), 1)], 512), [[_vShow, _ctx.video.loading]]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("video", _hoisted_5, null, 512)], 512), [[_vShow, !_ctx.video.loading]])]);
}